import { Container, Row, Col, Form } from "react-bootstrap"

export interface CollectorNotesProps {
  notes: string
  disabled?: boolean
  onChange: (value: string) => void
}

const CollectorNotes = (props: CollectorNotesProps) => {
  const { disabled = false } = props

  return (
    <Container fluid className='mt-3 mb-2'>
      <Row>
        <Col>
          <h6>Collector Notes</h6>
          <Form.Control as="textarea"
            placeholder="Insert collector's notes"
            disabled={disabled}
            value={props.notes}
            onChange={e => props.onChange(e.target.value)} />
        </Col>
      </Row>
    </Container>
  )
}

export default CollectorNotes
